exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content {\n  min-height: 100vh; }\n\n.pass-view-button {\n  border-radius: 4px;\n  background-color: transparent;\n  border: 0;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: left;\n  color: #2c023b;\n  cursor: pointer;\n  outline: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/login/login.component.scss
// module id = ../../../../../src/app/pages/login/login.component.scss
// module chunks = main